import React, { Component } from "react";
import "./header.scss";

class HeaderPage extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }

  componentDidMount() {  }

  render() {
    const { width, viewMenu } = this.props.initState

    return (
      <div className="headerPage__container">
        <img alt={'Logo ID'} className="headerPage__img" src="https://tarjeta.id/v1.0.0/img/id.png" />
        <span className="headerPage__title">Mi Panel</span>

      </div>
    );
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

};

export default HeaderPage